<template>
<div class="region-tab">
	<grid flat v-for="(value, key) in regionList" :key="key">
		<grid-item size="1/2" class="key">{{ key }}:</grid-item>
		<grid-item size="1/2" class="value">
			<span>
				{{ value }}
			</span>
		</grid-item>
	</grid>
</div>
</template>

<script>
export default {
	data: () => ({
		regionList: {
			'Total Area': '34,802 km²',
			'Population': '9,485,000',
			'Total Labour Force': '',
			'Unemployment Rate': '8.10%',
			'Avg Household Income': '',
			'Unique Feature': 'An autonomous province, not under the jurisdiction of the Regional Government.',
			'Percentage of national GDP': '17%',
			'Homes with internet': '52%',
			'Homes with portable water': '95%',
		}
	})
}
</script>

<style lang="scss">
.region-tab {
	text-align: left;
	color: #fff;
	font-size: 12px;
	font-weight: 200;
	padding-right: 16px;
	
	.key {
		font-weight: 500;
	}
	.value {
		display: flex;

		span {
			align-self: flex-end;
		}
	}
}
</style>
